import PropTypes from 'prop-types';
import Lottie from 'react-lottie';
import { REQUEST_STATES, ASSOCIATE_CONFIRMATION_ACTIONS } from '../../constants/constants';
import './styles.css';

const RectangleLayout = (props) => {
  const {
    smallIcon,
    coverImage,
    titleText,
    renderSupportiveText,
    belowText,
    requestState,
    getLocaleStr,
    userAction,
    didAssociateMeet,
    isNotYetOrNo,
    children,
  } = props;

  const defaultOptions = (animationData) => ({
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  });

  return (
    <>
      <div className="column round-rectangle">
        {!props.isCA && (
          <div className="row message-container">
            <div className="small-icon-container">
              <img src={smallIcon} alt="small-icon" />
            </div>
            <div className="column">
              <h3 className="roboto title-text">{titleText}</h3>
              <span className="roboto typography-regular subtitle-text">
                {renderSupportiveText()}
              </span>
            </div>
          </div>
        )}

        {coverImage?.animate ? (
          <Lottie
            style={{
              width: '15rem', height: '12rem', margin: '8%', alignSelf: 'center',
            }}
            options={defaultOptions(coverImage?.data)}
          />
        ) : <img src={coverImage?.data} className={props.isCA ? 'large-icon-ca' : 'large-icon'} alt={props.isCA ? 'large-icon-ca' : 'large-icon'} />}

        {props.isCA && (
          <>
            {!didAssociateMeet && (
            <>
              <div className="column">
                <h3 className="roboto title-text-ca">{titleText}</h3>
                <span className="roboto typography-regular subtitle-text-ca">
                  {renderSupportiveText()}
                </span>
              </div>
              {belowText && (
              <b className="roboto typography-regular subtitle-text-ca description-ca">
                {belowText}
              </b>
              )}
            </>
            )}

            {/* Render Confirmation Box */}
            {didAssociateMeet
              && (requestState === REQUEST_STATES.On_The_Way
                || requestState === REQUEST_STATES.Trck_Delivery_On_The_Way
                || requestState === REQUEST_STATES.Pending)
              && (
              <div className="confirmation-dialog">

                <p className="confirmation-message">{getLocaleStr('confirmation_message')}</p>
                <div className="confirmation-buttons">
                  <button
                    type="button"
                    className="not-yet-button"
                    onClick={() => userAction(
                      isNotYetOrNo === false
                        ? ASSOCIATE_CONFIRMATION_ACTIONS.NotYet
                        : ASSOCIATE_CONFIRMATION_ACTIONS.No,
                    )}
                  >
                    {getLocaleStr('no')}
                  </button>
                  <button
                    type="button"
                    className="yes-button"
                    onClick={() => userAction(ASSOCIATE_CONFIRMATION_ACTIONS.Yes)}
                  >
                    {getLocaleStr('yes')}
                  </button>
                </div>
              </div>
              )}
            {/* Render Children */}
            {!!children && children}
          </>
        )}

      </div>
      {belowText && !props.isCA && <b className="roboto typography-regular subtitle-text description">{belowText}</b>}
      {!props.isCA && !!children && children}
    </>
  );
};

RectangleLayout.propTypes = {
  isCA: PropTypes.bool.isRequired,
  smallIcon: PropTypes.string.isRequired,
  coverImage: (props, propName, componentName) => {
    const { isCA, coverImage } = props;

    if (!isCA && typeof coverImage !== 'string') {
      return new Error(
        `Invalid prop \`${propName}\` of value \`${coverImage}\` supplied to \`${componentName}\`, expected string when isCA is false.`,
      );
    }

    if (isCA && typeof coverImage !== 'object') {
      return new Error(
        `Invalid prop \`${propName}\` of value \`${coverImage}\` supplied to \`${componentName}\`, expected object when isCA is true.`,
      );
    }

    return null;
  },
  titleText: PropTypes.string.isRequired,
  renderSupportiveText: PropTypes.func.isRequired,
  belowText: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  // Props required when isCA is true
  requestState: PropTypes.string,
  getLocaleStr: PropTypes.func,
  userAction: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  didAssociateMeet: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types, react/require-default-props
  setDidAssociateMeet: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  isNotYetOrNo: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types, react/require-default-props
  setIsNotYetOrNo: PropTypes.func,
};

RectangleLayout.defaultProps = {
  belowText: '',
  children: undefined,
  coverImage: null,
  requestState: null,
  getLocaleStr: null,
  userAction: null,
  didAssociateMeet: false,
  isNotYetOrNo: false,
};

export default RectangleLayout;
